/**
 * @About 
 * This file is entry point of config
 */

import _ from 'lodash';
import { devSetting, stagSetting, prodSetting, localhostSetting } from './Setting';

//defaut setting
let defaultSetting = {
    api: {
        url: "https://dev.api.salt.paymeindia.in/api/",
        // AUTH: "Basic c29ydGVkX0F1dGg6TXpDWTd5S0ZubHl4dTdHdg==",
        mode:'cors'
    },

    stripe_key:process.env.REACT_APP_DEV_STRIPE_KEY
}
console.log('env',process.env);
let siteSetting = defaultSetting;

switch (process.env.REACT_APP_ENV) {
    case "prod":
    case "production":
        siteSetting = _.extend(defaultSetting, prodSetting);
        break;
    case "stag":
    case "staging":
        siteSetting = _.extend(defaultSetting, stagSetting);
        break;
    case "local":
    case "localhost":
        siteSetting = _.extend(defaultSetting, localhostSetting);
        break;
    case "dev":
    case "development":
        siteSetting = _.extend(defaultSetting, devSetting);
        break;
    default:
        siteSetting = _.extend(defaultSetting, devSetting);
}
export default siteSetting;